export {
  normalizeContributorsBasePath,
  getContributorPath,
  getContributorPathSegment,
} from '@highereducation/wordpress';
